require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-guessing-heugraben.json") })
        }
      }, "path---betreuungseinrichtungen-guessing-heugraben");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-guessing-heugraben!./.cache/json/betreuungseinrichtungen-guessing-heugraben.json
// module id = 891
// module chunks = 231608221292675